import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import cs from 'classnames';
import { addMonths, addYears, endOfMonth, format, getMonth, getYear, isAfter, isBefore, setMonth, startOfMonth } from 'date-fns';
import { sv } from 'date-fns/locale';
import range from 'lodash/range';
import ViewHeader from './ViewHeader';
import Cell from './Cell';
import { isDisabled } from './util';
export const MonthSelector = (props)=>{
    const { date, minDate, maxDate, setDate, prevView, nextView } = props;
    const year = getYear(date);
    const setDateRef = useRef(setDate);
    const prevViewRef = useRef(prevView);
    setDateRef.current = setDate;
    prevViewRef.current = prevView;
    useEffect(()=>{
        const selectMonth = (day)=>{
            const disabled = isDisabled(day, minDate, maxDate);
            if (!disabled) {
                setDateRef.current(day);
            }
        };
        const keydownHandler = (e)=>{
            switch(e.key){
                case 'ArrowRight':
                    selectMonth(addMonths(date, 1));
                    e.preventDefault();
                    break;
                case 'ArrowLeft':
                    selectMonth(addMonths(date, -1));
                    e.preventDefault();
                    break;
                case 'ArrowUp':
                    selectMonth(addMonths(date, -3));
                    e.preventDefault();
                    break;
                case 'ArrowDown':
                    selectMonth(addMonths(date, 3));
                    e.preventDefault();
                    break;
                case 'Enter':
                    prevViewRef.current();
                    e.preventDefault();
                    break;
            }
        };
        document.addEventListener('keydown', keydownHandler);
        return ()=>{
            document.removeEventListener('keydown', keydownHandler);
        };
    }, [
        date,
        minDate,
        maxDate
    ]);
    const monthCells = range(0, 12).map((i)=>{
        const monthLabel = format(setMonth(new Date(), i), 'LLL', {
            locale: sv
        });
        const m = setMonth(date, i);
        const start = startOfMonth(m);
        const end = endOfMonth(m);
        const disabled = isDisabled(m, start, end);
        const _class = cs({
            month: true,
            disabled: disabled,
            current: i === getMonth(date)
        });
        return /*#__PURE__*/ _jsx(Cell, {
            classes: _class,
            value: monthLabel,
            onClick: ()=>{
                if (!disabled) {
                    setDateRef.current(m);
                    prevView();
                }
            }
        }, i);
    });
    const next = ()=>{
        let nextDate = addYears(date, 1);
        if (maxDate && isAfter(nextDate, maxDate)) {
            nextDate = maxDate;
        }
        setDate(nextDate);
    };
    const prev = ()=>{
        let prevDate = addYears(date, -1);
        if (minDate && isBefore(prevDate, minDate)) {
            prevDate = minDate;
        }
        setDate(prevDate);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "months-view",
        children: [
            /*#__PURE__*/ _jsx(ViewHeader, {
                data: year.toString(),
                next: next,
                prev: prev,
                titleAction: nextView
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "months",
                children: monthCells
            })
        ]
    });
};
